module.exports = __webpack_public_path__ + "img/7_116.68820472.png";